"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySymbolCircularArrowImage = void 0;
var react_1 = __importDefault(require("react"));
var CurrencySymbolCircularArrowImage = function (props) {
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { opacity: "0.5", d: "M24 4C28.8 4 33.4 5.7 37 8.8V6H41V16H31V12H34.6C31.7 9.4 28 8 24 8C15.2 8 8 15.2 8 24C8 32.8 15.2 40 24 40C32.8 40 40 32.8 40 24H44C44 35 35 44 24 44C13 44 4 35 4 24C4 13 13 4 24 4Z", fill: "currentColor" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 30C27.3137 30 30 27.3137 30 24C30 20.6863 27.3137 18 24 18C20.6863 18 18 20.6863 18 24C18 27.3137 20.6863 30 24 30ZM24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33Z", fill: "currentColor" }),
        react_1.default.createElement("path", { d: "M23 20H25V23H27.5V25H23V20Z", fill: "currentColor" })));
};
exports.CurrencySymbolCircularArrowImage = CurrencySymbolCircularArrowImage;
